import { useEffect, useState } from 'react'; 
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { tissueTranslate } from "./dictionaries";

export default function ExpressionTissues(props: any) { 
    const { exprStage, exprItem, index } = props; 
    const [tissuesListData, setTissuesListData] = useState<any>([]);



    useEffect(() => { 
         
        //console.log("ET:",exprStage ,exprItem);
  
        if(!exprStage || !exprItem)
        {
          return;
        } 

        //build display tissue list
        if(exprItem.tissue && exprItem.tissue_positive)
        {
            let tissueArray = [];
            let tissuePositiveArray = []; 
            let denominator = 0;
            try{
                tissueArray = exprItem.tissue.split(";");
                tissuePositiveArray = exprItem.tissue_positive.split(";");
                denominator = exprItem.denominator;
            }
            catch{
                tissueArray = [exprItem.tissue];
                tissuePositiveArray = [exprItem.tissuePositiveArray];
                denominator = exprItem.denominator;
            }

            let tissuesList = [];
            for(let i=0; i<tissueArray.length; i++)
            {
                if(tissueArray[i] && tissuePositiveArray[i] && tissueArray[i]!=="" )
                {
                    tissuesList.push({ "tissue":tissueArray[i],  
                                        "tissuePositive":tissuePositiveArray[i],
                                        "denominator":denominator
                                    });
                }
            }
            setTissuesListData(tissuesList); 

        }

         
  
    }, [exprStage]);
 

    return ( 
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 900 }} aria-label="simple table">
          <TableHead >
            <TableRow> 
              {tissuesListData.map((tissueItem:any) => (
                    <TableCell key={tissueItem.tissue+"tissue"} sx={{ minWidth: 150 }}>{tissueTranslate(tissueItem.tissue, "label")}</TableCell> 
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {tissuesListData.map((tissueItem:any) => (
                    <TableCell key={tissueItem.tissue+"tissuepos"}>{tissueItem.tissuePositive} / {tissueItem.denominator}</TableCell> 
                ))}
              </TableRow>
            
          </TableBody>
        </Table>
        </TableContainer>
    ); 




 
      
   
   
  }